import React from 'react'
import styled from 'styled-components'
import Masonry from 'react-masonry-css'

const breakpointColumnsObj = {
  default: 4,
  1100: 3,
  700: 2,
  500: 1,
}

export default ({ children }: React.ComponentPropsWithoutRef<typeof Wrapper>) => (
  <Wrapper>
    <Masonry breakpointCols={breakpointColumnsObj} className="masonry-grid" columnClassName="masonry-grid_column">
      {children}
    </Masonry>
  </Wrapper>
)

// Styles
const Wrapper = styled.div`
  width: 100vw;
  position: relative;
  left: calc(-50vw + 50%);
  padding: 32px;
  .masonry-grid {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-left: -32px;
    width: auto;
    justify-content: center;
  }
  .masonry-grid_column {
    padding-left: 32px;
    background-clip: padding-box;
  }

  .masonry-grid_column > div {
    margin-bottom: 32px;
  }
`
